export default __webpack_public_path__ + "static/media/y_wdt_c_3.ca6bd0be.mp3";